import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('spenspot-theme');
    return saved || 'system';
  });
  
  const [actualTheme, setActualTheme] = useState('light');

  useEffect(() => {
    const updateTheme = () => {
      let newTheme = theme;
      
      if (theme === 'system') {
        // Check system preference
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        newTheme = prefersDark ? 'dark' : 'light';
      } else if (theme === 'auto') {
        // Auto based on time (dark from 20h to 7h)
        const hour = new Date().getHours();
        newTheme = (hour >= 20 || hour < 7) ? 'dark' : 'light';
      }
      
      setActualTheme(newTheme);
      
      // Apply to document
      if (newTheme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };

    updateTheme();
    
    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', updateTheme);
    
    // Update every minute for auto mode
    const interval = theme === 'auto' ? setInterval(updateTheme, 60000) : null;
    
    return () => {
      mediaQuery.removeEventListener('change', updateTheme);
      if (interval) clearInterval(interval);
    };
  }, [theme]);

  const setThemeMode = (mode) => {
    setTheme(mode);
    localStorage.setItem('spenspot-theme', mode);
  };

  return (
    <ThemeContext.Provider value={{ theme, actualTheme, setTheme: setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
